.header {
  padding: calc(var(--safe-t) + 18px) var(--gutter) 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.header h1 {
  font-size: var(--fs-2xl);
  font-weight: 800;
  letter-spacing: -0.03em;
}

.search {
  display: flex;
  align-items: center;
  gap: 10px;
  height: 46px;
  padding: 0 16px;
  border-radius: var(--r-md);
  background: var(--surface-2);
  color: var(--text-3);
  font-weight: 600;
  text-align: left;
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 18px var(--gutter) 0;
}

.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 14px 0 6px;
  border-radius: var(--r-full);
  background: var(--surface-1);
  border: 1px solid var(--border);
  font-weight: 700;
  font-size: var(--fs-sm);
  transition: border-color var(--t-fast), background var(--t-fast);
}

.tag:hover {
  border-color: var(--accent);
}

.tag small {
  color: var(--text-3);
  font-weight: 600;
  margin-left: 4px;
}

.hash {
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: var(--accent-soft);
  color: var(--accent);
  font-weight: 800;
}

.trendGrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  padding: 0 var(--gutter);
}

.trendTile {
  position: relative;
  aspect-ratio: 3 / 4;
  border-radius: 12px;
  overflow: hidden;
  background: var(--surface-2);
}

.trendTile img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--t-slow) var(--ease);
}

.trendTile:hover img {
  transform: scale(1.05);
}

.trendTile::after {
  content: '';
  position: absolute;
  inset: 50% 0 0;
  background: linear-gradient(to top, rgb(0 0 0 / 0.75), transparent);
}

.rank {
  position: absolute;
  top: 6px;
  left: 8px;
  z-index: 1;
  font-size: 22px;
  font-weight: 800;
  color: white;
  text-shadow: 0 2px 8px rgb(0 0 0 / 0.6);
}

.trendTile:nth-child(-n + 3) .rank {
  color: var(--accent);
}

.trendMeta {
  position: absolute;
  left: 8px;
  right: 8px;
  bottom: 6px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  font-size: 11px;
  text-align: left;
}

.trendMeta strong {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.trendMeta span {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  color: var(--text-2);
}

.rows {
  padding: 0 8px;
}

/* ---------- search page ---------- */
.searchHeader {
  position: sticky;
  top: 0;
  z-index: 10;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: calc(var(--safe-t) + 8px) var(--gutter) 8px 4px;
  background: rgb(0 0 0 / 0.92);
  backdrop-filter: blur(18px);
}

.back {
  display: grid;
  place-items: center;
  width: 40px;
  height: 40px;
}

.searchField {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 14px;
  border-radius: var(--r-md);
  background: var(--surface-2);
  color: var(--text-3);
  border: 1px solid transparent;
}

.searchField:focus-within {
  border-color: var(--accent);
}

.searchField input {
  flex: 1;
  min-width: 0;
  background: none;
  border: 0;
  outline: none;
  color: var(--text);
  font-size: var(--fs-md);
}

.chipsWrap {
  padding: 4px 0 4px;
}

.recent {
  padding: 16px var(--gutter);
}

.recent h2 {
  font-size: var(--fs-md);
  font-weight: 800;
  margin-bottom: 8px;
}

.recentItem {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 0;
  color: var(--text-2);
  font-weight: 600;
  text-align: left;
}

.center {
  display: grid;
  place-items: center;
  padding: 48px;
  color: var(--text-3);
}

.more {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--accent);
}

.artist {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  max-width: 120px;
  text-align: center;
  font-size: var(--fs-sm);
  font-weight: 700;
}

.artist span,
.artist small {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.artist small {
  color: var(--text-3);
  font-weight: 600;
}

.tagHero {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 8px var(--gutter) 20px;
}

.tagHero h1 {
  font-size: var(--fs-xl);
  font-weight: 800;
}

.tagHero p {
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.tagBadge {
  display: grid;
  place-items: center;
  width: 80px;
  height: 80px;
  border-radius: 20px;
  background: var(--accent-soft);
  color: var(--accent);
  font-size: 40px;
  font-weight: 800;
}
